export enum QueryParams {
    ModalMode = 'modalMode'
}



// WEBPACK FOOTER //
// ./src/app/helpers/queryParams.enum.ts